var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsGr = function SvgNnIconFlagsGr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2,
    cy: 16.2,
    r: 16,
    fill: "#fff",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0095ff",
    d: "M13.3.43q-1.172.211-2.28.586v6.47h7.03v-3.49h8.44a15.9 15.9 0 0 0-7.53-3.57c-3.23-.493-5.65 0-5.65 0zm4.75 7.05v3.49h13.2c-.418-1.23-.984-2.4-1.69-3.49zm0 3.49h-7.03v6.98h21c.068-.599.109-1.21.109-1.82 0-.562-.03-1.12-.088-1.66h-13.9zM7.55 2.71a15.9 15.9 0 0 0-4.79 4.78h4.79zm-6.47 8.26Q.66 12.2.447 13.49v4.46h7.11v-6.98zm.057 10.5a15.8 15.8 0 0 0 1.73 3.49h26.6c.717-1.09 1.3-2.26 1.73-3.49zm4.85 6.97c2.12 1.75 4.65 2.93 7.36 3.41 0 0 2.3.484 5.65 0 2.71-.481 5.24-1.66 7.36-3.41z"
  })));
};
export default SvgNnIconFlagsGr;